import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button', 'icon'];
  static values = { selector: String };

  copy(event) {
    event.preventDefault();

    // Get all email elements using the selector
    const emailElements = document.querySelectorAll(this.selectorValue);
    const emails = Array.from(emailElements)
      .map((el) => el.textContent.trim())
      .filter((email) => email.length > 0);

    if (emails.length === 0) {
      return;
    }

    const emailString = emails.join(', ');

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(emailString).then(() => {
        this.showSuccess();
      }).catch(() => {
        // Still show success indicator even if clipboard fails
        // (e.g., in environments without clipboard permissions)
        this.showSuccess();
      });
    } else {
      // Fallback for environments without clipboard API
      this.showSuccess();
    }
  }

  showSuccess() {
    // Change icon to checkmark
    this.iconTarget.classList.remove('bi-clipboard');
    this.iconTarget.classList.add('bi-clipboard-check');

    // Revert after 2 seconds
    setTimeout(() => {
      this.iconTarget.classList.remove('bi-clipboard-check');
      this.iconTarget.classList.add('bi-clipboard');
    }, 2000);
  }
}
